export default __webpack_public_path__ + "static/media/xls.a43bbf12.svg";